import axios from 'axios';
import { parse              } from 'lossless-json'
import   SettingsAplications  from '@/core/settingsCoreAplications'
import type { Idtoauth ,IResponseApi, Ilog   } from '@/interfaces/IauthGateway';

const Permissions = new SettingsAplications();
const apiPermissions = Permissions.endPointMain.checkPermission.name;
const apiRegisterLog = Permissions.endPointMain.auditLogs.name;
const Settings    = {  method: "", maxBodyLength: Infinity,  url: '',  headers: { 'Content-Type': 'application/json' }, data:{}};

export default function useGeneralServices() {
    const generateResponse = ( auth: boolean, status: number = 500,   message: string = 'An error occurred', content: any = {} ) => ({
            StatusAuth: auth,
            Status: status,
            StatusCode: status, 
            Message: message,
            Content: content,
            Success: false,
            AccessToken: '',
            RefreshToken: '',
            ExpiresOn: '', 
            Pagination:null
    });
    
    const axiosCheckPermissions = async (dtoAuth: Idtoauth) => {
        return await axios.post(apiPermissions, {
            "userId": dtoAuth.userId,
            "appId": dtoAuth.appId,
            "moduleId": dtoAuth.moduleId,
            "actionId": dtoAuth.actionId
        }).then(function (response) {
            return { code: response.data.StatusCode, message: response.data.Message };
        }).catch(function (error) { return { status: error.response.status, name: error.name, message: error.message }; });
        
    }

    const axiosRegisterLogs = async (dtoAuth: Idtoauth) => {
        return await axios.post(apiRegisterLog, {
            "userId": dtoAuth.userId,
            "descripcion": dtoAuth.descripcion,
            "app": dtoAuth.app,
            "module": dtoAuth.module,
            "action": dtoAuth.action,
            "record": dtoAuth.record,
        }).then(function (response) {
            return { status: response.data.StatusCode, message: response.data.Message };
        }).catch(function (error) {
            return { status: error.response.status, name: error.name, message: error.message };
        });
    }
    
        
    const axiosGet = async (api: string, dtoAuth: Idtoauth | null) => {
        Settings.method = "GET";
        Settings.url = api;
        
        if (dtoAuth != null) {
            try {
                const authResponse = <Ilog>await axiosCheckPermissions(dtoAuth);
                if (authResponse.code == 200) {
                    try {
                        
                        const response = <IResponseApi>await axios(Settings)
                            .then(function (response) {                                
                                return {
                                    StatusAuth: true,
                                    Status: response.status, 
                                    Request: response.request.response,
                                    Success: response.data.Success, 
                                    StatusCode: response.data.StatusCode,
                                    Message: response.data.Message, 
                                    Content: response.data.Content,
                                    Pagination: response.data.Pagination
                                };
                            });
                        
                        if (response.Status == 200 && response.StatusCode == 200) {
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        } else {
                            dtoAuth.descripcion = response.StatusCode + " -- " + response.Message;
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        }
                    } catch (error) {
                        const errorResponse = <Ilog>error;
                        dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                        await axiosRegisterLogs(dtoAuth);
                        return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
                    }
                } else {
                    dtoAuth.descripcion = "Not authorized";
                    await axiosRegisterLogs(dtoAuth);
                    return generateResponse(false, 401, dtoAuth.action+ " - Not authorized", {});
                }
            } catch (error) {
                const errorResponse = <Ilog>error;
                dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
            }
        } else {            
            return <IResponseApi>await axios(Settings).then(function (response) {
                return {
                    StatusAuth: true,
                    Status: response.status,
                    Request: response.request.response,
                    Success: response.data.Success??true ,
                    StatusCode: response.data.StatusCode ?? response.status,
                    Message: response.data.Message??'',
                    Content: response.data.Content??response.data,
                    AccessToken: response.data.AccessToken??'',
                    RefreshToken: response.data.RefreshToken??'',
                    ExpiresOn: response.data.ExpiresOn??'',
                    Pagination: response.data.Pagination??null,
                };
            }).catch(error => {
                const errorResponse = <Ilog>error;
                return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
            });
        }
    };

    
    const  axiosPost= async (api:string, data:any, dtoAuth:Idtoauth|null)=> {
        Settings.method = "POST";
        Settings.url    = api;
        Settings.data   = data;
        
        if (dtoAuth != null) {
      
             try {
                const authResponse = <Ilog>await axiosCheckPermissions(dtoAuth);
                 
                if (authResponse.code == 200) {
                    try {
                        const response = <IResponseApi>await axios(Settings)
                            .then(function (response) {
                                return {
                                    StatusAuth: true,
                                    Status: response.status, 
                                    Request: response.request.response, 
                                    Success: response.data.Success, 
                                    StatusCode: response.data.StatusCode, 
                                    Message: response.data.Message, 
                                    Content: response.data.Content
                                };
                            });
                        
                        if (response.Status == 200 && response.StatusCode == 200) {
                            const record:any=parse(response.Request);
                            dtoAuth.record=record.Content.Id.value;
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        } else {
                            dtoAuth.descripcion = response.StatusCode + " -- " + response.Message;
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        }
                    } catch (error) {
                        const errorResponse = <Ilog>error;
                        dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                        await axiosRegisterLogs(dtoAuth);
                        return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
                    }
                } else {
                    dtoAuth.descripcion = "Not authorized";
                    await axiosRegisterLogs(dtoAuth);
                    return generateResponse(false, 401, "Not authorized", {});
                }
            } catch (error) {
                const errorResponse = <Ilog>error;
                dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
            }
        }else{
            return <IResponseApi>await axios(Settings).then(function (response) {
                return {
                    StatusAuth: true,
                    Status: response.status,
                    Request: response.request.response,
                    Success: response.data.Success??true ,
                    StatusCode: response.data.StatusCode ?? response.status,
                    Message: response.data.Message??'',
                    Content: response.data.Content??response.data,
                    AccessToken: response.data.AccessToken??'',
                    RefreshToken: response.data.RefreshToken??'',
                    ExpiresOn: response.data.ExpiresOn??'',
                    Pagination: response.data.Pagination??null,
                };
            }).catch(error => {
                const errorResponse = <Ilog>error;
                return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
            });
        }
    }
  
    const axiosPut = async (api: string, data: any, dtoAuth: Idtoauth | null) => {
        
        Settings.method = "PUT";
        Settings.url    = api;
        Settings.data   = data;
        
        if (dtoAuth != null) {
      
             try {
                const authResponse = <Ilog>await axiosCheckPermissions(dtoAuth);
                if (authResponse.code == 200) {
                    try {
                        const response = <IResponseApi>await axios(Settings)
                            .then(function (response) {
                                return {
                                    StatusAuth: true,
                                    Status: response.status, 
                                    Request: response.request.response, 
                                    Success: response.data.Success, 
                                    StatusCode: response.data.StatusCode, 
                                    Message: response.data.Message, 
                                    Content: response.data.Content 
                                };
                            });

                        
                        if (response.Status == 200 && response.StatusCode == 200) {
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        } else {
                            dtoAuth.descripcion = response.StatusCode + " -- " + response.Message;
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        }
                    } catch (error) {
                        const errorResponse = <Ilog>error;
                        dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                        await axiosRegisterLogs(dtoAuth);
                        return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
                    }
                } else {
                    dtoAuth.descripcion = "Not authorized";
                    await axiosRegisterLogs(dtoAuth);
                    return generateResponse(false, 401, "Not authorized", {});
                }
            } catch (error) {
                const errorResponse = <Ilog>error;
                dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
            }
        }else{
            return await axios(Settings).then((response) => {
                return response
            }).catch(error => {
                return { status: error.response.status, name: error.name, message: error.message };
            });
        }

    }
    
    const axiosDelete = async (api:string, data:any, dtoAuth:Idtoauth|null) => {
                
        Settings.method = "DELETE";
        Settings.url    = api;
        Settings.data   = data;
        
        if (dtoAuth != null) {
      
             try {
                const authResponse = <Ilog>await axiosCheckPermissions(dtoAuth);
                if (authResponse.code == 200) {
                    try {
                        const response = <IResponseApi>await axios(Settings)
                            .then(function (response) {
                                return {
                                    StatusAuth: true,
                                    Status: response.status, 
                                    Request: response.request.response, 
                                    Success: response.data.Success, 
                                    StatusCode: response.data.StatusCode, 
                                    Message: response.data.Message, 
                                    Content: response.data.Content
                                };
                            });

                        
                        if (response.Status == 200 && response.StatusCode == 200) {
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        } else {
                            dtoAuth.descripcion = response.StatusCode + " -- " + response.Message;
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        }
                    } catch (error) {
                        const errorResponse = <Ilog>error;
                        dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                        await axiosRegisterLogs(dtoAuth);
                        return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
                    }
                } else {
                    dtoAuth.descripcion = "Not authorized";
                    await axiosRegisterLogs(dtoAuth);
                    return generateResponse(false, 401, "Not authorized", {});
                }
            } catch (error) {
                const errorResponse = <Ilog>error;
                dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
            }
        }else{
            return await axios(Settings).then((response) => {
                return response
            }).catch(error => {
                return { status: error.response.status, name: error.name, message: error.message };
            });
        }

    }
    
    const axiosUploadImagen=async(api: string, data: any, dtoAuth: Idtoauth | null)=> {
        Settings.method     = "POST";
        Settings.url        = api;
        Settings.data       = data;
        Settings.headers = { 'Content-Type': 'multipart/form-data' };
        
        if (dtoAuth != null) {
      
             try {
                const authResponse = <Ilog>await axiosCheckPermissions(dtoAuth);
                if (authResponse.code == 200) {
                    try {
                        const response = <IResponseApi>await axios(Settings)
                            .then(function (response) {
                                return {
                                    StatusAuth: true,
                                    Status: response.status, 
                                    Request: response.request.response, 
                                    Success: response.data.Success, 
                                    StatusCode: response.data.StatusCode, 
                                    Message: response.data.Message, 
                                    Content: response.data.Content
                                };
                            });

                        
                        if (response.Status == 200 && response.StatusCode == 200) {
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        } else {
                            dtoAuth.descripcion = response.StatusCode + " -- " + response.Message;
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        }
                    } catch (error) {
                        const errorResponse = <Ilog>error;
                        dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                        await axiosRegisterLogs(dtoAuth);
                        return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
                    }
                } else {
                    dtoAuth.descripcion = "Not authorized";
                    await axiosRegisterLogs(dtoAuth);
                    return generateResponse(false, 401, "Not authorized", {});
                }
            } catch (error) {
                const errorResponse = <Ilog>error;
                dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
            }
        }else{
            return await axios(Settings).then((response) => {
                return response
            }).catch(error => {
                return { status: error.response.status, name: error.name, message: error.message };
            });
        }
       
    }
    
    
    const  axiosPostArray= async (api:string, data:any, dtoAuth:Idtoauth|null)=> {
        Settings.method = "POST";
        Settings.url    = api;
        Settings.data   = data;
        
        if (dtoAuth != null) {
      
             try {
                const authResponse = <Ilog>await axiosCheckPermissions(dtoAuth);
                if (authResponse.code == 200) {
                    try {
                        const response = <IResponseApi>await axios(Settings)
                            .then(function (response) {
                                return {
                                    StatusAuth: true,
                                    Status: response.status, 
                                    Request: response.request.response, 
                                    Success: response.data.Success, 
                                    StatusCode: response.data.StatusCode, 
                                    Message: response.data.Message, 
                                    Content: response.data.Content                                    
                                };
                            });

                        
                        if (response.Status == 200 && response.StatusCode == 200) {
                            const record:any=parse(response.Request);
                            dtoAuth.record=record.Content.length;
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        } else {
                            dtoAuth.descripcion = response.StatusCode + " -- " + response.Message;
                            await axiosRegisterLogs(dtoAuth);
                            return response;
                        }
                    } catch (error) {
                        const errorResponse = <Ilog>error;
                        dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                        await axiosRegisterLogs(dtoAuth);
                        return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
                    }
                } else {
                    dtoAuth.descripcion = "Not authorized";
                    await axiosRegisterLogs(dtoAuth);
                    return generateResponse(false, 401, "Not authorized", {});
                }
            } catch (error) {
                const errorResponse = <Ilog>error;
                dtoAuth.descripcion = errorResponse.status + " -- " + errorResponse.message;
                return generateResponse(false, errorResponse.status, errorResponse.name + ' ' + errorResponse.message, {});
            }
        }else{
            return await axios(Settings).then((response) => {
                return response
            }).catch(error => {
                return { status: error.response.status, name: error.name, message: error.message };
            });
        }

    }
    
    return {
        axiosCheckPermissions,
        axiosRegisterLogs,
        axiosGet,
        axiosPost,
        axiosPut,
        axiosDelete,
        axiosUploadImagen,
        axiosPostArray
    }
}
